module.exports = __webpack_public_path__ + "img/2023-29.4109de6c.jpg";